import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';

import { RestrictedGateway } from 'src/features/membershipType/types';
import DeleteRestrictedGateway from 'src/features/membership/components/forms/restrictedGateway/DeleteRestrictedGateway';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { membershipTypeMessages } from 'src/features/membershipType/utils/messages';

interface CellRestrictedGatewayActionsProps<TData, TValue> extends CellContext<TData, TValue> {
    restrictedGateways?: string[];
    isMembershipTemplateActive: boolean;
}
export default function CellRestrictedGatewayActions<TData, TValue>({
    row,
    restrictedGateways,
    isMembershipTemplateActive,
}: CellRestrictedGatewayActionsProps<TData, TValue>) {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span className="inline-block">
                        <DeleteRestrictedGateway
                            selectedRestrictedGateway={row.original as RestrictedGateway}
                            restrictedGateways={restrictedGateways}
                        >
                            <Button
                                size="icon"
                                variant="link"
                                className="cursor-pointer hover:bg-gray-100"
                                disabled={isMembershipTemplateActive}
                            >
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </DeleteRestrictedGateway>
                    </span>
                </TooltipTrigger>
                <TooltipContent className="max-w-56">
                    <FormattedMessage
                        {...(!isMembershipTemplateActive
                            ? generalMessages.delete
                            : membershipTypeMessages.activeMembershipTypeProtectedError)}
                    />
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
